import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'formatPrice'
})
export class FormatPricePipe implements PipeTransform {
	/**
	* Formata o valor recebido para ter a saída :  '- R$ 1.235,50' ou '+ R$ 1.235,50'
	* @param value: valor a ser formatado
	*/
	transform(value: any, signal = true): any {
		if (Number(value) < 0) {
			value = '- R$ ' + (Number(value) * -1).toLocaleString('de-DE', { maximumFractionDigits: 2, minimumFractionDigits: 2 });
		} else if (Number(value) > 0) {
			value = '+ R$ ' + Number(value).toLocaleString('de-DE', { maximumFractionDigits: 2, minimumFractionDigits: 2 });
		} else {
			value = 'R$ ' + Number(value).toLocaleString('de-DE', { maximumFractionDigits: 2, minimumFractionDigits: 2 });
		}

		if (!signal) {
			value = value.replace('- ', '');
			value = value.replace('+ ', '');
		}
		return value;
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/shared/format-price.pipe.ts